// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quill {
  box-shadow: 0 0 0 1px rgba(63, 63, 68, 0.05), 0 1px 3px rgba(63, 63, 68, 0.1), 0 1px 2px rgba(0, 0, 0, 0.05);
  background-color: #fff;
  border: none;
  border-radius: 3px;
}

.ql-container {
  min-height: 380px;
  padding: 5px !important;
  background-color: #fff;
  box-shadow: none;
  border: none !important;
}

/* Make editor text area fill the container div so
 * the user can click anywhere to focus when the
 * editor is empty
 */
.ql-editor {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.ql-short-height .ql-container, .ql-short-height .ql-editor {
  min-height: 120px !important;
}

.ql-container p, .ql-container ol, .ql-container ul {
  font-size: 15px;
}

/* variable name tag inserted into text flow */

.quill .badge-tmpl {
  background: #30b5c7;
  color: white;
  display: inline-block;
  padding: .25em .4em;
  font-size: 88%;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: .25rem;
}

.ql-toolbar {
  background: #fff;
  border: none !important;
  border-bottom: 1px solid rgba(63, 63, 68, 0.1) !important;
}

*/ .ReactModal__Body--open {
  overflow: hidden;
  position: fixed;
  width: 100%;
  height: 100%;
}

.text-editor {
  position: relative;
}

.tmpl-var-dropdown {
  position: absolute;
  padding: 20px 0 0 0 !important;
  left: 252px;
  top: 42px;
  background: white;
  border: 1px solid #00000038;
  z-index: 10;
  font-size: 14px;
}

.tmpl-var-dropdown ul {
  margin: 0;
  padding: 0;
}

.tmpl-var-dropdown li {
  list-style-type: none;
  margin: 0;
  padding: 0 8px 0 11px;
  cursor: pointer;
  border-top: 1px solid #e2e2e2;
  display: block;
}

.tmpl-var-dropdown li:hover {
  background-color: whitesmoke;
}

.character_counter {
  display: flex;
  justify-content: flex-end;
  padding: 5px;
  border-top: 1px solid rgb(217, 217, 217);
  border-image: initial;
  background-color: #fff;
  box-shadow: 0 0 0 1px rgba(63, 63, 68, 0.05), 0 1px 3px rgba(63, 63, 68, 0.1), 0 1px 2px rgba(0, 0, 0, 0.05);
}

@media (max-width: 642px) {
  .tmpl-var-dropdown {
    left: 130px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/message-editor/editor.css"],"names":[],"mappings":"AAAA;EACE,4GAA4G;EAC5G,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;;EAGE;AACF;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,eAAe;AACjB;;AAEA,8CAA8C;;AAE9C;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,yDAAyD;AAC3D;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,WAAW;EACX,SAAS;EACT,iBAAiB;EACjB,2BAA2B;EAC3B,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,SAAS;EACT,qBAAqB;EACrB,eAAe;EACf,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,wCAAwC;EACxC,qBAAqB;EACrB,sBAAsB;EACtB,4GAA4G;AAC9G;;AAEA;EACE;IACE,WAAW;EACb;AACF","sourcesContent":[".quill {\n  box-shadow: 0 0 0 1px rgba(63, 63, 68, 0.05), 0 1px 3px rgba(63, 63, 68, 0.1), 0 1px 2px rgba(0, 0, 0, 0.05);\n  background-color: #fff;\n  border: none;\n  border-radius: 3px;\n}\n\n.ql-container {\n  min-height: 380px;\n  padding: 5px !important;\n  background-color: #fff;\n  box-shadow: none;\n  border: none !important;\n}\n\n/* Make editor text area fill the container div so\n * the user can click anywhere to focus when the\n * editor is empty\n */\n.ql-editor {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n\n.ql-short-height .ql-container, .ql-short-height .ql-editor {\n  min-height: 120px !important;\n}\n\n.ql-container p, .ql-container ol, .ql-container ul {\n  font-size: 15px;\n}\n\n/* variable name tag inserted into text flow */\n\n.quill .badge-tmpl {\n  background: #30b5c7;\n  color: white;\n  display: inline-block;\n  padding: .25em .4em;\n  font-size: 88%;\n  font-weight: 700;\n  line-height: 1;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  border-radius: .25rem;\n}\n\n.ql-toolbar {\n  background: #fff;\n  border: none !important;\n  border-bottom: 1px solid rgba(63, 63, 68, 0.1) !important;\n}\n\n*/ .ReactModal__Body--open {\n  overflow: hidden;\n  position: fixed;\n  width: 100%;\n  height: 100%;\n}\n\n.text-editor {\n  position: relative;\n}\n\n.tmpl-var-dropdown {\n  position: absolute;\n  padding: 20px 0 0 0 !important;\n  left: 252px;\n  top: 42px;\n  background: white;\n  border: 1px solid #00000038;\n  z-index: 10;\n  font-size: 14px;\n}\n\n.tmpl-var-dropdown ul {\n  margin: 0;\n  padding: 0;\n}\n\n.tmpl-var-dropdown li {\n  list-style-type: none;\n  margin: 0;\n  padding: 0 8px 0 11px;\n  cursor: pointer;\n  border-top: 1px solid #e2e2e2;\n  display: block;\n}\n\n.tmpl-var-dropdown li:hover {\n  background-color: whitesmoke;\n}\n\n.character_counter {\n  display: flex;\n  justify-content: flex-end;\n  padding: 5px;\n  border-top: 1px solid rgb(217, 217, 217);\n  border-image: initial;\n  background-color: #fff;\n  box-shadow: 0 0 0 1px rgba(63, 63, 68, 0.05), 0 1px 3px rgba(63, 63, 68, 0.1), 0 1px 2px rgba(0, 0, 0, 0.05);\n}\n\n@media (max-width: 642px) {\n  .tmpl-var-dropdown {\n    left: 130px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
